import { useEffect, useState } from "react";
import { Table, Tag, message, Modal, Image } from "antd";
import {
  WarningOutlined,
  MobileOutlined,
  UserOutlined,
  CameraOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import axios from "../../utils/axios";

const AlertPage = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const cafeId = localStorage.getItem("cafeId");
  const username = user?.username;

  const fetchAlerts = async () => {
    if (!username) return;
    try {
      setLoading(true);
      const res = await axios.post("/fetch-alerts", { username, cafeId });
      if (res.data.success) {
        const formattedAlerts = res.data.alerts.map((a, index) => ({
          key: index,
          type: a.alertType,
          camera: a.cameraId,
          time: new Date(a.createdOn).toLocaleString(),
          severity: (a.severity || a.Severity).toLowerCase(),
          imageUrl: a.alertUrl,
        }));

        setAlerts(formattedAlerts);
      } else {
        message.error("Failed to fetch alerts");
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching alerts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  const openModal = (record) => {
    setSelectedAlert(record);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAlert(null);
  };

  const columns = [
    {
      title: "Alert Type",
      dataIndex: "type",
      key: "type",
      render: (text) => (
        <span className="flex items-center gap-2">
          {text.includes("Mobile") && <MobileOutlined />}
          {text.includes("Overcrowding") && <UserOutlined />}
          {text.includes("Camera") && <CameraOutlined />}
          {text}
        </span>
      ),
    },
    {
      title: "Camera",
      dataIndex: "camera",
      key: "camera",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Severity",
      dataIndex: "severity",
      key: "severity",
      render: (severity = "low") => {
        const value = severity.toLowerCase();
        return (
          <Tag
            color={
              value === "high"
                ? "red"
                : value === "medium"
                ? "orange"
                : "gold"
            }
          >
            {value.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "view",
      align: "center",
      render: (_, record) => (
        <EyeOutlined
          style={{ fontSize: 18, color: "#1677ff", cursor: "pointer" }}
          onClick={() => openModal(record)}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          <WarningOutlined className="text-red-500" />
          Alerts
        </h1>
        <p className="text-gray-500">
          Live & historical alerts generated by cameras
        </p>
      </div>

      {/* Alert Table */}
      <Table
        columns={columns}
        dataSource={alerts}
        loading={loading}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: ['10', '25', '50', '100'],
          showSizeChanger: true,
          showQuickJumper: false,
        }}
      />

      {/* 🔹 VIEW IMAGE MODAL */}
      <Modal
        title="Alert Evidence"
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        width={600}
        centered
      >
        {selectedAlert?.imageUrl ? (
          <Image
            src={selectedAlert.imageUrl}
            alt="Alert"
            style={{ width: "100%", borderRadius: 8 }}
          />
        ) : (
          <p>No image available</p>
        )}
      </Modal>
    </div>
  );
};

export default AlertPage;